import { render, staticRenderFns } from "./PageOrgChart.vue?vue&type=template&id=2761152f&"
import script from "./PageOrgChart.vue?vue&type=script&lang=js&"
export * from "./PageOrgChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports